// extracted by mini-css-extract-plugin
module.exports = {"teams-adding":"_2kU-tUsAo59ML7Jr-z4M","select":"_3lg7DvPrKC4LYhjhSnyf"};